import { ETestIds } from 'shared/constants/testIds';

export const getOffersAnchorElement = (): Element | null => {
  return (
    document.querySelector(`[data-testid=${ETestIds.ShortOffersList}]`) ||
    document.querySelector(`[data-testid=${ETestIds.ShortOffersEmpty}]`) ||
    null
  );
};
